<script>
    import { Link, useLocation } from 'svelte-routing';
    import {base} from '../../utils/base';
    export let className = '';
    
    let isDropdownOpen = false;
    
    const location = useLocation();
    
    let dropdownContainer;
    
    // Add function to check if route is active
    $: isActive = (path) => {
        return $location.pathname === path;
    };

    const dashboardLinks = [
        // { name: 'Resources Accounting Tool', url: 'http://geoapps.icimod.org/resourcesinfo' },
        { name: 'GLOFs in High Mountain Asia', url: 'https://www.icimod.org/mountain-hazards/?p=glof' },
        { name: 'Hydropower Plants in Nepal', url: 'https://icimod.maps.arcgis.com/apps/dashboards/e599934a6b3649f4a5eb1e59c077bf6c' },
        { name: 'Forest Fire in Nepal', url: 'http://nepal.spatialapps.net/NepalForestFire/FireStats' },
        // { name: 'Forest Fire in Bhutan', url: 'https://geoapps.icimod.org/BhutanForestFire/FireStats' }
    ];

    // Function to close dropdown
    const closeDropdown = () => {
        isDropdownOpen = false;
    };

    // Handle clicks outside dropdown
    function handleClickOutside(event) {
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
            isDropdownOpen = false;
        }
    }
    
    // Add and remove event listener
    $: if (isDropdownOpen) {
        document.addEventListener('click', handleClickOutside);
    } else {
        document.removeEventListener('click', handleClickOutside);
    }
    
    // Cleanup on component destroy
    import { onDestroy } from 'svelte';
    onDestroy(() => {
        document.removeEventListener('click', handleClickOutside);
    });
</script>

<nav class='bg-white shadow-md w-full px-4 py-2 {className}'>
    <div class="max-w-7xl mx-auto flex items-center justify-between">
        <div class="flex space-x-4">
            <Link 
                to="{base}/" 
                class="inline-flex items-center px-4 py-2 text-sm font-medium !text-gray-700 no-underline hover:text-blue-600 hover:bg-gray-50 rounded-md transition duration-150 {isActive(base + '/') ? 'bg-blue-50 !text-blue-600' : ''}"
            >
                Home
            </Link>
            <Link 
                to="{base}/datasets" 
                class="inline-flex items-center px-4 py-2 text-sm font-medium !text-gray-700 no-underline hover:text-blue-600 hover:bg-gray-50 rounded-md transition duration-150 {isActive(base + '/datasets') ? 'bg-blue-50 !text-blue-600' : ''}"
            >
                Datasets
            </Link>
            <Link 
                to="{base}/mapViewer" 
                class="inline-flex items-center px-4 py-2 text-sm font-medium !text-gray-700 no-underline hover:text-blue-600 hover:bg-gray-50 rounded-md transition duration-150 {isActive(base + '/mapViewer') ? 'bg-blue-50 !text-blue-600' : ''}"
            >
                Map Viewer
            </Link>
            <div class="relative inline-block text-left" bind:this={dropdownContainer}>
                <button 
                    on:click={() => isDropdownOpen = !isDropdownOpen}
                    type="button" 
                    class="inline-flex items-center px-4 py-2 text-sm font-medium !text-gray-700 border-transparent focus:border-transparent focus:ring-0 hover:text-blue-600 hover:bg-gray-50 rounded-md transition duration-150"
                    id="menu-button" 
                    aria-expanded={isDropdownOpen}
                    aria-haspopup="true"
                >
                    Dashboards
                    <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>

                {#if isDropdownOpen}
                    <ul 
                        class="text-black origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50" 
                        role="menu" 
                        aria-orientation="vertical" 
                        aria-labelledby="menu-button"
                    >
                        {#each dashboardLinks as link}
                            <li role="none">
                                <a 
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="!text-gray-700 block px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-600 transition duration-150 no-underline"
                                    role="menuitem"
                                    on:click={closeDropdown}
                                >
                                    {link.name}
                                </a>
                            </li>
                        {/each}
                    </ul>
                {/if}
            </div>
        </div>
    </div>
</nav>
  